import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./solid/bell-ringing.svg";
var BellRingingSolid_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  BellRingingSolid_default as default
};
